<script setup lang="ts">
defineProps<{ link: string }>();
</script>

<template>
  <a
    class="btn-link return-link"
    :href="link"
  >
    <span class="return-link__icon" />
  </a>
</template>
